import OptionSwitcher from "../../OptionSwitch";
import React, { useState, createContext, useEffect } from "react";
import { OPTION_TAB_VALUE } from "../../../constants/option-tab-value";
import TrainerList from "../../TrainerList";
import SmartMatchingOverview from "../real-time-smart-matching/SmartMatchingOverview";

export const RealTimeLectureContext = createContext({ translation: {} });

export default function RealTimeLectureList({ props }) {
  const options = [
    {
      label: props.titleSmartMatching,
      value: OPTION_TAB_VALUE.SMART_MATCHING,
    },
    { label: props.titleAllTutors, value: OPTION_TAB_VALUE.ALL_TUTORS },
  ];

  // Initialize optionsTab from URL query parameter or default to first option
  const getInitialTabValue = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    return tabParam && options.some(option => option.value === tabParam) 
      ? tabParam 
      : OPTION_TAB_VALUE.ALL_TUTORS;
  };

  const [optionsTab, setOptionsTab] = useState(getInitialTabValue());

  const handleSelection = (option) => {
    setOptionsTab(option);
    // Update URL query parameter
    const url = new URL(window.location);
    const params = url.searchParams;
    ['page', 'rows', 'sortBy', 'dayAvailable', 'startTime', 'endTime', 'nationality', 
     'startTuition', 'endTuition', 'gender', 'courseContent', 'languageSpoken', 'teacherStyle'].forEach(param => {
      params.delete(param);
    });
    params.set('tab', option);
    window.history.pushState({}, '', url);
  };

  const handleNavigationFromPortal = () => {
    setOptionsTab(OPTION_TAB_VALUE.ALL_TUTORS);
  };

  useEffect(() => {
    if (props.titleSmartMatchingProps?.trainerPublicId) {
      handleNavigationFromPortal();
    }
  }, [props.titleSmartMatchingProps?.trainerPublicId]);

  // Handle browser navigation (back/forward buttons)
  useEffect(() => {
    const handlePopState = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get('tab');
      if (tabParam && options.some(option => option.value === tabParam)) {
        setOptionsTab(tabParam);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [options]);

  const renderTabs = (option) => {
    switch (option) {
      case OPTION_TAB_VALUE.ALL_TUTORS:
        if (!props.titleSmartMatchingProps) {
          return null;
        }
        return <TrainerList props={props.titleSmartMatchingProps} messages={props.messages}/>;
      default:
        return <SmartMatchingOverview props={props.smartMatchingProps} messages={props.messages} />;
    }
  };

  return (
    <RealTimeLectureContext.Provider value={{ translation: props }}>
      {/* <div className="mx-auto my-5 flex justify-content-center animate__animated  animate__flipInY">
        <OptionSwitcher
          options={options}
          onSelect={handleSelection}
          size="large"
          selected={optionsTab}
        />
      </div> */}

      {renderTabs(optionsTab)}
    </RealTimeLectureContext.Provider>
  );
}
